import { useRef } from "react";
import { SnackbarProvider, closeSnackbar } from "notistack";
import { IconButton } from "@material-ui/core";

export default function CustomSnackbarProvider({ children }) {
  const notistackRef = useRef(null);
  return (
    <SnackbarProvider
      ref={notistackRef}
      maxSnack={5}
      autoHideDuration={3500}
      variant="info"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={(id) => (
        <IconButton
          size="small"
          onClick={() => closeSnackbar(id)}
          sx={{ p: 0.5, color: "white" }}
          color="inherit"
        >
          x
        </IconButton>
      )}
    >
      {children}
    </SnackbarProvider>
  );
}
